.controlButtons {
    position: fixed;
    bottom: 90px;
    left: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
}

.floatingButton {
    cursor: pointer;

    border: none;
    padding: 0;
    margin: 0;
    outline: none;
    box-shadow: none;

    font-size: 40px;
    padding-left: 5px;
    padding-right: 5px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #000000a6;
    min-height: 60px;
    min-width: 60px;

    display: flex;
    justify-content: center;
    align-items: center;

    transition: opacity ease 0.3s;

    &:hover {
        background: #f5f5f5;
    }
}